import { Action } from '@ngrx/store';
import {
  IntegrationImportErrorResult,
  IntegrationImportErrorsParams,
  IntegrationImportParams,
  IntegrationImportResult
} from './integration-imports.interface';

export const GET_INTEGRATION_IMPORTS = 'GET_INTEGRATION_IMPORTS';
export const GET_INTEGRATION_IMPORTS_SUCCESS = 'GET_INTEGRATION_IMPORTS_SUCCESS';
export const GET_INTEGRATION_IMPORTS_FAILURE = 'GET_INTEGRATION_IMPORTS_FAILURE';
export const SET_INTEGRATION_IMPORTS_PARAMS = 'SET_INTEGRATION_IMPORTS_PARAMS';

export const GET_INTEGRATION_IMPORT_ERRORS = 'GET_INTEGRATION_IMPORT_ERRORS';
export const GET_INTEGRATION_IMPORT_ERRORS_SUCCESS = 'GET_INTEGRATION_IMPORT_ERRORS_SUCCESS';
export const GET_INTEGRATION_IMPORT_ERRORS_FAILURE = 'GET_INTEGRATION_IMPORT_ERRORS_FAILURE';
export const SET_INTEGRATION_IMPORT_ERRORS_PARAMS = 'SET_INTEGRATION_IMPORT_ERRORS_PARAMS';

export class GetIntegrationImportsAction implements Action {
  readonly type = GET_INTEGRATION_IMPORTS;

  constructor(public payload: IntegrationImportParams) {}
}

export class GetIntegrationImportsSuccessAction implements Action {
  readonly type = GET_INTEGRATION_IMPORTS_SUCCESS;

  constructor(public payload: IntegrationImportResult) {}
}

export class GetIntegrationImportsFailureAction implements Action {
  readonly type = GET_INTEGRATION_IMPORTS_FAILURE;

  constructor(public payload: any) {}
}

export class SetIntegrationImportsParamsAction implements Action {
  readonly type = SET_INTEGRATION_IMPORTS_PARAMS;

  constructor(public payload: IntegrationImportParams) {}
}

export class GetIntegrationImportErrorsAction implements Action {
  readonly type = GET_INTEGRATION_IMPORT_ERRORS;

  constructor(public payload: IntegrationImportErrorsParams) {}
}

export class GetIntegrationImportErrorsSuccessAction implements Action {
  readonly type = GET_INTEGRATION_IMPORT_ERRORS_SUCCESS;

  constructor(public payload: IntegrationImportErrorResult) {}
}

export class GetIntegrationImportErrorsFailureAction implements Action {
  readonly type = GET_INTEGRATION_IMPORT_ERRORS_FAILURE;

  constructor(public payload: any) {}
}

export class SetIntegrationImportErrorsParamsAction implements Action {
  readonly type = SET_INTEGRATION_IMPORT_ERRORS_PARAMS;

  constructor(public payload: IntegrationImportErrorsParams) {}
}

export type IntegrationImportActions =
  | GetIntegrationImportsAction
  | GetIntegrationImportsSuccessAction
  | GetIntegrationImportsFailureAction
  | SetIntegrationImportsParamsAction;

export type IntegrationImportErrorsActions =
  | GetIntegrationImportErrorsAction
  | GetIntegrationImportErrorsSuccessAction
  | GetIntegrationImportErrorsFailureAction
  | SetIntegrationImportErrorsParamsAction;
